import React, { useEffect, useState, useRef, useLayoutEffect } from "react";

// services
import { putContract } from "../../services/contract";
import { useForm, Controller } from "react-hook-form";

// misc
import { formOptions } from "../constants/misc";

// components
import DigitalSignature from "../DigitalSignature";
import { Box, Button, CircularProgress, Grid, Switch, Typography, Link } from "@mui/material";
import { pagesUrl, redirectPage } from "../../utils/misc";
import { useDeviceDetector } from "../../hooks/useDeviceDetector";

export default function SignatureModal({
  data,
  userId,
  brandId,
  setShowStatusModal,
  setRequestStatus,
  setOpenSignaturetModal,
  memberSignature,
  customerSignature,
  setMemberSignature,
  setCustomerSignature,
  stampedMemberSignature,
  stampedCustomerSignature,
  isMember,
  isCustomer,
  ip,
}) {
  const [existingMemberSignature, setExistingMemberSignature] = useState(false);
  const [existingCustomerSignature, setExistingCustomerSignature] =
    useState(false);

  // card
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");

  const [addNewCard, setAddNewCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [currentCard, setCurrentCard] = useState(0);

  const [canSignContract, setCanSignContract] = useState(false);

  const [copyFormOptions, setUnderAge] = useState(formOptions);

  const [newFormOptions, setNewFormOptions] = useState([]);

  const currentBrand = localStorage.getItem("current_brand");

  const { device } = useDeviceDetector();

  const [ isPermanence , setIsPermanence] = useState(false);

  const [ checkedPermanence  , setCheckedPermanence] = useState(false);

  const [ urlContractPermanence , setUrlContractPermanence] = useState("");

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (data.headers.customer_signature) {
      setExistingCustomerSignature(data.headers.customer_signature);
    }
    if (data.headers.member_signature) {
      setExistingMemberSignature(data.headers.member_signature);
    }

  }, []);

  useEffect(() => {//Se valida si el contrato tiene permanencia y se optiene el contrato de permanencia
    data.contracts?.map((contract) => {
      if (contract.is_permanence == 1 && brandId == 1) {
        setIsPermanence(true);
      }

      if (contract?.name_contract && contract?.name_contract === "ANEXO_CONTRATO_UNICO_DE_PRESTACION_DE_SERVICIOS.pdf" && contract?.contract_url) {
        setUrlContractPermanence(contract.contract_url)
      }
    });
  }, []);

  useLayoutEffect(() => {//Validaciones de menores de edad o contratos con permanencia
    const { under_age } = data.headers;

    const filtered = copyFormOptions.filter((item) => !item.under_age);

    if (under_age === 0) {
      const new_filtered = isPermanence ? filtered : filtered.filter((item) => !item.permanence);
      setNewFormOptions(new_filtered);
    } else {
      const new_filtered = isPermanence ? copyFormOptions : copyFormOptions.filter((item) => !item.permanence);
      setNewFormOptions(new_filtered);
    }
  }, [data.headers, isPermanence, copyFormOptions]);


  const onSubmit = async (value) => {
    setIsLoading(true)
    for (const key in value) {
      if (value[key]) {
        value[key] = 1;
      } else {
        value[key] = 0;
      }
    }

    const submitData = {
      ...value,
      agreement_line_uuid: userId,
      brand_id: Number(brandId),
      signature_customer: stampedCustomerSignature,
      signature_member: stampedMemberSignature,
    };

    if (data.cards) {
      if (addNewCard) {
        const expladeExpiryCard = expiry.split("/");

        submitData["name"] = cardName;
        submitData["expiration_month"] = expladeExpiryCard[0].replace(
          /\s/g,
          ""
        );
        submitData["security_code"] = cvc;
        submitData["expiration_year"] =
          "20" + expladeExpiryCard[1].replace(/\s/g, "");
        submitData["card_number"] = cardNumber;
      } else {
        submitData["payment_method_id"] = currentCard;
      }
    }

    submitData["request_server"] = `IP: ${ip}, ${window.navigator.userAgent}`;
    submitData["log"] = device;

    try {
      const response = await putContract(submitData);
      setRequestStatus(response.data.message);
      redirectPage(pagesUrl[currentBrand] + (Number(currentBrand) === 1 ? 'servicios/pilates' : ''));
    } catch (err) {
      setRequestStatus("Error al firmar contrato");
    } finally {
      setIsLoading(false)
      setShowStatusModal(true);
      setOpenSignaturetModal(false);
    }
  };

  useEffect(() => {
    if (data?.cards) {
      setCurrentCard(data.cards[0]?.payment_method_id);
    }
  }, [data]);

  useEffect(() => {
    if (memberSignature || customerSignature) {
      setCanSignContract(true);
    } else {
      setCanSignContract(false);
    }
  }, [memberSignature, customerSignature]);

  const onError = () => {};
  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container alignItems={"center"} spacing={1}>
            {newFormOptions.map((item, idx) => (
              <>
                <Grid item xs={10}>
                  <Typography fontSize={"12px"}>
                    {item?.contact && <p>Autorizo recibir información comercial a través de:</p>}
                    {item?.url && <p style={{ color: "red" }}>Campo obligatorio *</p>}
                    {item.title}
                    {item?.url && <Link href={urlContractPermanence} target={"_blank"}> {item?.text_url}</Link>}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  {item?.contact && <br></br>}
                  <Box
                    display={"flex"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                  >
                    <Box mx={1}>
                      <Controller
                        control={control}
                        name={item.name}
                        error={errors[item.name]}
                        defaultValue={item.default}
                        render={({ field }) => (
                          <Switch
                            {...field}
                            defaultChecked={item.default ?? false}
                            onChange={(e)=>{
                              field.onChange(e.target.checked)
                              if(item?.permanence){
                                setCheckedPermanence(e.target.checked)
                              }
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Box>
                </Grid>
              </>
            ))}
          </Grid>
        </Grid>

        {isCustomer && (
          <Grid item xs={12}>
            <Typography py={1}>
              {`Firma Titular Del Contrato: ${data.headers.customer_name}, ${data.headers.customer_document_type} ${data.headers.customer_document_number}`}
            </Typography>
            {existingCustomerSignature ? (
              <Box mb={4} display={"flex"} justifyContent={"center"}>
                <img
                  style={{ objectFit: "cover", width: "100%" }}
                  src={existingCustomerSignature}
                />
              </Box>
            ) : (
              <DigitalSignature setSignature={setCustomerSignature} />
            )}
          </Grid>
        )}

        {isMember && (
          <Grid item xs={12}>
            <Typography
              py={1}
            >{`Firma Afiliado: ${data.headers.member_name}, ${data.headers.member_document_type} ${data.headers.member_document_number}`}</Typography>
            {existingMemberSignature ? (
              <Box mb={4} display={"flex"} justifyContent={"center"}>
                <img
                  style={{ objectFit: "cover", width: "100%" }}
                  src={existingMemberSignature}
                />
              </Box>
            ) : (
              <DigitalSignature setSignature={setMemberSignature} />
            )}
          </Grid>
        )}

        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"flex-end"} mb={1}>
            <Button
              disabled={!canSignContract || isLoading || (isPermanence && !checkedPermanence)}
              type="submit"
              variant="contained"
            >
              {isLoading ? <CircularProgress size={30} color="primary" /> : <span>{"Firmar"}</span>}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
}
